<template>
  <div
    class="form-group"
    :class="{ 'has-error': errors.has(validationName), 'form-group-active': active }"
  >
    <label class="control-label" v-if="label">{{ label }}</label>
    <multiselect
      :noOptions="messages.noOptions"
      :value="value"
      :options="options"
      :disabled="disabled"
      group-values="options"
      group-label="labelGroup"
      :group-select="true"
      :showLabels="false"
      :groupSelect="false"
      :placeholder="placeholder"
      track-by="value"
      label="text"
      selectLabel="Pressione enter para selecionar"
      selectGroupLabel="Pressione enter para selecionar o grupo"
      deselectLabel="Pressione enter para remover"
      deselectGroupLabel="Pressione enter para remover o grupo"
      @input="$emit('input', $event)"
      @change="$emit('input', $event)"
      @blur="changeFocus()"
      @focus="changeFocus()"
    >
      <span slot="noResult">{{messages.noResult}}</span>
      <span slot="maxElements">{{messages.maxElements}}</span>
      <span slot="noOptions">{{messages.noOptions}}</span>
    </multiselect>
    <error-message :message="errors.first(validationName)"></error-message>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  inject: ["$validator"],
  name: "form-group-search-select-group",
  components: {
    Multiselect
  },
  props: {
    label: String,
    id: String,
    name: String,
    scope: String,
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    required: String,
    value: null,
    options: Array
  },
  data() {
    return {
      active: false,
      messages: {
        noOptions: "Nenhuma opção disponível",
        noResult: "Nenhum registro encontrado",
        maxElements: `Número máximo opções selecionadas`
      }
    };
  },
  computed: {
    validationName() {
      return this.scope ? `${this.scope}.${this.name}` : this.name;
    }
  },
  mounted() {
    this.$el.value = this.value;
  },
  methods: {
    changeFocus() {
      this.active = !this.active;
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.multiselect__tags {
  border-radius: 3px !important;
  border: 1px solid #ccc !important;
}
.multiselect__option {
  font-size: 13px !important;
}
.multiselect__option--highlight {
  background: rgba(108, 117, 125, 0.1) !important;
  color: #35495e !important;
}
.multiselect__option--selected.multiselect__option--highlight {
  background: rgba(108, 117, 125, 0.1) !important;
  color: #6f859c !important;
}
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Forms/FormGroupSearchSelectGroup.vue